var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCircleArrowDown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_154_2181)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2.86377C6.48 2.86377 2 7.34377 2 12.8638C2 18.3838 6.48 22.8638 12 22.8638C17.52 22.8638 22 18.3838 22 12.8638C22 7.34377 17.52 2.86377 12 2.86377ZM12 20.8638C7.59 20.8638 4 17.2738 4 12.8638C4 8.45377 7.59 4.86377 12 4.86377C16.41 4.86377 20 8.45377 20 12.8638C20 17.2738 16.41 20.8638 12 20.8638Z",
    fill: "#323232"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_154_2181)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.33031 12.7255L11.2159 15.5453C11.6504 15.9699 12.3523 15.9699 12.7868 15.5453L15.6724 12.7255C16.3743 12.0396 15.873 10.8638 14.8814 10.8638H9.11021C8.11863 10.8638 7.62841 12.0396 8.33031 12.7255Z",
    fill: "#323232"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_154_2181"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.86377)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_154_2181"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.86377)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleArrowDown);
export default __webpack_public_path__ + "static/media/circle_arrow_down.cf1826d6704950b34d078da56fdc9d6e.svg";
export { ForwardRef as ReactComponent };